export enum ProcedureDepartment {
  GENERAL_SURGERY = "GENERAL SURGERY",
  MEDICAL_CASES = "Medical Cases",
  ORTHOPAEDIC = "ORTHOPAEDIC",
  NEUROSURGERY = "NEUROSURGERY",
  CARDIOLOGY = "Cardiology",
  UROLOGY = "UROLOGY",
  GYNAECOLOGY = "GYNAECOLOGY",
  OPHTHALMOLOGY = "OPHTHALMOLOGY",
  ENDOSCOPIC_PROCEDURES = "ENDOSCOPIC PROCEDURES",
  PAEDS_CARDIOLOGY = "Paeds Cardiology",
  DENTAL = "DENTAL",
  THROAT = "THROAT",
  EAR = "EAR",
  NOSE = "NOSE",
  PAEDIATRIC = "PAEDIATRIC",
  ENDOCRINE = "ENDOCRINE",
  CARDIAC_SURGERY = "Cardiac Surgery",
  ADVANCED_ADD_PROCEDURES = "Advanced Add.Procedures",
  TERTIARY_PRIORITY = "Tertiary/Priority",
  OTHER = "Other"
}
